import React, { useState } from "react";
import styles from "./index.module.css";
import { resetProformaUser } from "../../store/reducers/proformaReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useNavigate } from "react-router-dom";
import img from "../../assets/images/InceptionFinicallyLogo.png";
import CustomButton from "../Button/CustomButton";
import GlobalModal from "../../helpers/GlobalModal";
import ExistingProforma from "../Proforma/ExistingProforma";
import ProformaLocated from "../Proforma/ProformaLocated";

interface LinkProps {
  folderUrl: string;
  onReset: () => void;
  resetForm: () => void;
  handleClientEmail: () => void;
  proformaId: string;
  contactEmail: string;
}

const ProformaResponse: React.FC<LinkProps> = ({
  proformaId,
  contactEmail,
  folderUrl,
  onReset,
  resetForm,
  handleClientEmail,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profromaUserDetails = useSelector(
    (state: RootState) => state.proformaUser
  );
  const [isExistingProformaModalOpen, setIsExistingProformaModalOpen] =
    useState(false);
  const [isProformaLocatedModalOpen, setIsProformaLocatedModalOpen] =
    useState(false);
  const [getProformaId, setProformaId] = useState(proformaId);
  const [getContactEmail, setContactEmail] = useState(contactEmail);
  const [proformaMatchStatus, setProformaMatchStatus] = useState<
    boolean | null
  >(null);
  const [proformaLocatedMessage, setProformaLocatedMessage] = useState("");
  const [isAlreadyFinalized, setIsAlreadyFinalized] = useState(false);

  const handleProformaCheckResult = (
    isMatch: ExistingProformaResponse,
    enteredProformaId: string
  ) => {
    setIsExistingProformaModalOpen(false);
    setIsAlreadyFinalized(false);
    setProformaMatchStatus(isMatch?.output === "true" ? true : false);

    if (isMatch?.proformaList?.Pro_Forma_ID == enteredProformaId) {
      setIsAlreadyFinalized(true);
      setProformaLocatedMessage(
        `You already have proforma with Proforma ID: ${
          isMatch.proformaList.Pro_Forma_ID
        } as Finalized Proforma for ${new Date().getFullYear()}.`
      );
    } else if (!isMatch?.proformaList?.Pro_Forma_ID) {
      setProformaLocatedMessage("");
    } else if (
      isMatch?.proformaList?.Pro_Forma_ID != enteredProformaId &&
      isMatch?.proformaList?.Pro_Forma_ID
    ) {
      setProformaLocatedMessage(
        `You currently have proforma with Proforma ID: ${
          isMatch.proformaList.Pro_Forma_ID
        } as Finalized Proforma for ${new Date().getFullYear()}.`
      );
    }
    if (isMatch.output === "false") {
      setProformaLocatedMessage(isMatch.userMessage[0] || "");
    }
    setIsProformaLocatedModalOpen(true);
  };

  const handleLogout = () => {
    localStorage.clear();
    dispatch(resetProformaUser());
    navigate("/proforma");
  };

  const resetValues = () => {
    handleClientEmail();
    resetForm();
    onReset();
  };

  return (
    <>
      <div className={styles.page}>
        <div className={styles.header}>
          <div>
            <img src={img} alt="" className={`${styles.image}`} />
          </div>
          <div>
            <button
              onClick={handleLogout}
              className={`relative h-12 bg-[#3B755E] cursor-pointer rounded ${styles.logoutButton}`}
            >
              LOGOUT
            </button>
          </div>
        </div>
        <div className={styles.content}>
          <h1 className={`font-bold text-center ${styles.formHeader}`}>
            Your proforma is ready.
          </h1>
          {folderUrl && (
            <a className={styles.link} target="_blank" href={folderUrl}>
              Click here to go to Google Drive Folder
            </a>
          )}
        </div>

        <div className="flex justify-evenly py-6">
          <CustomButton
            onClick={onReset}
            buttonLabel="Rerun Scenario"
            style={{ width: "12rem" }}
          />
          <CustomButton
            onClick={() => setIsExistingProformaModalOpen(true)}
            buttonLabel="Finalize Proforma"
            style={{ width: "12rem" }}
          />
          <CustomButton
            onClick={resetValues}
            buttonLabel="New Scenario"
            style={{ width: "12rem" }}
          />
        </div>
      </div>
      <GlobalModal
        open={isExistingProformaModalOpen}
        setOpen={setIsExistingProformaModalOpen}
      >
        <ExistingProforma
          proformaId={proformaId}
          contactEmail={contactEmail}
          onProformaCheckResult={handleProformaCheckResult}
          setProformaId={setProformaId}
          setContactEmail={setContactEmail}
        />
      </GlobalModal>
      <GlobalModal
        open={isProformaLocatedModalOpen}
        setOpen={setIsProformaLocatedModalOpen}
      >
        {proformaMatchStatus !== null && (
          <ProformaLocated
            isMatch={proformaMatchStatus}
            proformaId={getProformaId}
            contactEmail={getContactEmail}
            message={proformaLocatedMessage}
            setIsProformaLocatedModalOpen={setIsProformaLocatedModalOpen}
            isAlreadyFinalized={isAlreadyFinalized}
          />
        )}
      </GlobalModal>
    </>
  );
};

export default ProformaResponse;
